// @ts-nocheck
class WIarpop extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Ar pop opening listener
        document.querySelector('.WI_productGallery_AR_Pop')?.addEventListener("click", (e)=>{
            let sku = e.target.getAttribute('data-arurl');
            e.preventDefault();
            this.addIframeUrl(sku);
            this.openAr();
        });
        // Ar pop closing listener
        document.querySelector('.WI_arPop_pop_cls_btn')?.addEventListener("click", (e)=>{
            e.preventDefault();
            this.closeAr();
        });
    }

    // open AR pop 
    openAr() {
        document.dispatchEvent(new CustomEvent("open:background", { bubbles: true }));
        this.style.display = "block";
        requestAnimationFrame(()=>{
            this.classList.add('WI_arPop_main_active');
        });
    }

    // close AR pop
    closeAr() {
        this.style.display = "none";
        setTimeout(() => {
            this.classList.remove('WI_arPop_main_active');
            document.dispatchEvent(new CustomEvent("close:background", { bubbles: true }));
        },210);
    }

    // Add iframe url
    addIframeUrl(sku) {
        console.log(sku);
        let arIframe = document.getElementById('WI_arPop_pop_iframe');
        let arUrl = `https://koreman.floori.io/?sku=${sku}`;
        arIframe.src = arUrl;
    }
}

customElements.define('wi-arpop',WIarpop);